/* eslint-disable import/no-cycle */
import hasPermission from '../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../shared/utils/access-control/enums/permissions';
import {
  getUserPlanCode,
  getUserPlanType,
} from '../../../../../shared/utils/user-details';
import { isValueBasedPlan } from '../../../../settings/components/billing-subscription/components/outreach-plans/utils/helper';
import {
  UserSetting,
  UserSettingCode,
} from '../../../../../shared/types/user-setting';
import { SubscriptionPlans } from '../../../../../shared/utils';

export const checkShouldShowBillings = () =>
  hasPermission(Permissions.BILLING_SHOW) &&
  (getUserPlanCode() === SubscriptionPlans.TRIAL ||
    isValueBasedPlan(getUserPlanType()) ||
    hasPermission(Permissions.ACCOUNT_SUBSCRIPTION_READ));

export const UNREAD_MAX_LIMIT = 200;

const isSidebarInfoShown = 'isSidebarInfoShown';

export const getIsSidebarInfoShown = () =>
  sessionStorage.getItem(isSidebarInfoShown);

export const setIsSidebarInfoShown = (value: string) =>
  sessionStorage.setItem(isSidebarInfoShown, value);

export const removeIsSidebarInfoShown = () =>
  sessionStorage.removeItem(isSidebarInfoShown);

export const isShowSidebarIntro = (meta: UserSetting[]): boolean => {
  if (Array.isArray(meta) && meta.length > 0) {
    const showSidebar = meta.find(
      (setting) => setting.code === UserSettingCode.ShowSidebar,
    );
    if (showSidebar) {
      return showSidebar.value === '1';
    }
  }
  return false;
};
